import { ErrorPage, ErrorPageInfo } from '@interacta-shared/data-access-error';

export type ErrorPageEntity = 'POST';

export const errorPageInfoRegistryConfig: Partial<
    Record<ErrorPage, Partial<Record<ErrorPageEntity, ErrorPageInfo>>>
> = {
    pageNotFound: {
        POST: {
            title: 'ERROR_PAGE.404.TITLE_POST',
            description: 'ERROR_PAGE.404.DESCRIPTION_POST',
            logout: false,
        },
    },
};
